const ENV = process.env.REACT_APP_BACKEND_ENV === "live" ? "live" : "dev";

const CONFIG = {
  live: {
    BASE_URL: "https://api-prod.grouped.com/admin/v1",
    SOCKET_BASE_URL: "",
    STRIPE_API_KEY: "",
    SOCIAL_CREDENTIALS: {
      facebookAppId: "",
      googleClientId: "",
    },
    AWS_IMAGE_BUCKET_NAME: "",
    LAMBDA_CHOPS_API:
      "https://jc6emv2599.execute-api.us-east-1.amazonaws.com/prod/v1",
  },
  dev: {
    BASE_URL: "https://api-dev.grouped.com/admin/v1",
    // BASE_URL: "http://localhost:3001/admin/v1", // Uncomment for local development
    SOCKET_BASE_URL: "",
    STRIPE_API_KEY: "",
    SOCIAL_CREDENTIALS: {
      facebookAppId: "",
      googleClientId: "",
    },
    AWS_IMAGE_BUCKET_NAME: "",
    LAMBDA_CHOPS_API:
      "https://bi2zoo1yfg.execute-api.us-east-1.amazonaws.com/dev/v1",
  },
};

export const BASE_URL = CONFIG[ENV].BASE_URL;
export const SOCKET_BASE_URL = CONFIG[ENV].SOCKET_BASE_URL;
export const STRIPE_API_KEY = CONFIG[ENV].STRIPE_API_KEY;
export const SOCIAL_CREDENTIALS = CONFIG[ENV].SOCIAL_CREDENTIALS;
export const AWS_IMAGE_BUCKET_NAME = CONFIG[ENV].AWS_IMAGE_BUCKET_NAME;
export const LAMBDA_CHOPS_API = CONFIG[ENV].LAMBDA_CHOPS_API;

export const DEFAULT_PROFILE_PICTURE =
  require("../assets/img/default-profile.svg").default;
